import { useState, useEffect } from 'react';
import {
  Box,
  BoxProps,
  Heading,
  HeadingProps,
  Link,
  ListItem,
  ListProps,
  StackProps,
  Text,
  UnorderedList,
  VStack,
} from '@chakra-ui/react';
import { getPublicRuntimeConfig } from '../common/config';
import { REQUIRED_COMMUNITY_GUIDELINE_VERSION } from '../common/constants';

/**
 * Antaaコミュニティガイドライン本文
 */
export default function CommunityGuidelines() {
  const { communityGuidelineUrlPrefix } = getPublicRuntimeConfig();
  const communityGuidelineUrl = `${communityGuidelineUrlPrefix}${REQUIRED_COMMUNITY_GUIDELINE_VERSION}.html`;
  const [iframeHeight, setIframeHeight] = useState(0);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        if (window.innerWidth <= 768) {
          const iHeight = window.innerHeight - 100;
          setIframeHeight(iHeight);
        } else {
          const iHeight = window.innerHeight - 270;
          setIframeHeight(iHeight);
        }
      };

      window.addEventListener('resize', handleResize);
      handleResize();
      return () => window.removeEventListener('resize', handleResize);
    } else {
      return;
    }
  }, []);

  return (
    <VStack align="stretch" lineHeight={1.8} p={2} wordBreak="break-all">
      <iframe
        id="communityGuidelineSummary"
        src={communityGuidelineUrl}
        width="100%"
        height={iframeHeight}
        frameBorder="0"
        marginWidth={0}
        marginHeight={0}
        style={{
          maxWidth: '100%',
        }}
        allowFullScreen
      ></iframe>
    </VStack>
  );
}
